import maintenanceImage from "../../assets/maintenance.png";

const MaintenancePage = () => (
  <div
    style={{
      display: "flex",
      flexDirection: "column",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      textAlign: "center",
      background: "#FFF9DF",
      color: "#333",
      overflow: "auto",
    }}
  >
    <h1 className="text-primary">We'll be back soon!</h1>
    <p className="text-primary">
      DataCutter is currently down for scheduled maintenance.
      <br />
      Please check back shortly.
    </p>
    <img
      className="rounded"
      height={"500px"}
      src={maintenanceImage}
      alt="Maintenance"
    />
  </div>
);

export default MaintenancePage;
